import type { DetailedHTMLProps, InputHTMLAttributes, ReactNode } from 'react'
import type { UseFormRegisterReturn } from 'react-hook-form'

export const FormField = ({
  label,
  registerProps,
  button,
  ...fieldProps
}: {
  label: string | JSX.Element
  registerProps: UseFormRegisterReturn
  button?: ReactNode
} & DetailedHTMLProps<
  InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>) => (
  <div className="form-group flex flex-col gap-2">
    <div className="mb-1 flex flex-row justify-between">
      <label htmlFor="input" className="text-1xl text-gray-800">
        {label}
      </label>
      {button}
    </div>
    <input
      type="text"
      autoComplete="false"
      className="block w-full rounded-md border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-serblue-light focus:ring-serblue-light"
      {...fieldProps}
      {...registerProps}
    />
  </div>
)
